export const AuthLinkRequest = () => <div className='title'>
  <h1>Auth - hello, hello...</h1>
</div>;